import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Banner } from '@shared/interfaces/banner/baner.interface';
import { StorageService } from '@shared/services/storage.service';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-ph-banner',
  templateUrl: './ph-banner.component.html',
  styleUrls: ['./ph-banner.component.scss'],
})
export class PhBannerComponent extends BaseComponent implements OnInit {
  @Input() item: Banner;
  @Input() font: string = '$font-family-base';
  @Input() color: string = '$wcd-yellow';
  public innerWidth: any;
  public screenWidth: any;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
  }

  constructor(public storage: StorageService) {
    super();
  }

  isLogged() {
    return this.storage.user ? true : false;
  }

  generateUrlWithFragment(link, fragment) {
    const anchor = fragment ? `#${fragment}` : '';

    return `/${link}${anchor}`;
  }
}
